<template>
  <div class="root">
    <div><img class="mainImg" :src="mainImg" /></div>
    <p class="titleText">{{ title }}</p>
    <p class="descText">{{ desc }}</p>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import i18n from '@/i18n';
import { getAppIcon } from '../../../utils/RegionAssets';

const title = ref('');
const desc = ref('');
const mainImg = computed(() => getAppIcon());

onMounted(() => {
  title.value = i18n.global.t('template.title');
  desc.value = i18n.global.t('template.desc');
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.root {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  background: url('../../../assets/img/template000_data0000_img2.png') no-repeat;
  background-position: center top;
  background-size: cover;
  flex-direction: column;
}

.mainImg {
  margin: 0 auto;
  margin-top: 100px;
  width: 100px;
  height: 100px;
}

.titleText {
  margin: 0 auto;
  width: 100%;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  color: #0d0d0d;
  opacity: 0.9;
  line-height: 40px;
}

.descText {
  margin: 4px auto;
  width: 100%;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: #0d0d0d;
  opacity: 0.66;
  line-height: 30px;
}
</style>
